/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { messages } from '../../../../messages';
import RelatedLinkItem from '../related-link-item';
var RelatedLinksList = function RelatedLinksList(_ref) {
  var urls = _ref.urls,
    title = _ref.title,
    testId = _ref.testId;
  return jsx(Stack, {
    testId: testId
  }, jsx(Box, {
    paddingBlockStart: "space.050"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ,
    xcss: xcss({
      font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
      textTransform: 'uppercase'
    })
  }, jsx(FormattedMessage, title)), urls.length > 0 && jsx(Box, null, urls.map(function (url, idx) {
    return jsx(Stack, {
      key: "".concat(idx, "-").concat(url)
    }, jsx(RelatedLinkItem, {
      url: url,
      testId: "".concat(testId, "-item-").concat(idx)
    }));
  })), urls.length === 0 &&
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
  jsx(Box, {
    paddingBlock: "space.100",
    xcss: xcss({
      font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    })
  }, jsx(FormattedMessage, messages.related_links_not_found)));
};
export default RelatedLinksList;